import React, { useEffect, useState } from "react";
import { Form, Card, Row, Col, Offcanvas, Badge } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyOnboardingService } from "../../../../../APIServices/studyOnboarding";
import SplitPane from "react-split-pane";
import Swal from "sweetalert2";
import CorierProperties from "../CorierProperties/CorierProperties";
import UpdateCorier from "./UpdateCorier";
import DeletedCorier from "./DeletedCorier";
import CorierUpdatedHistory from "../CorierProperties/CorierUpdatedHistory";
import CorierActivities from "../CorierProperties/CorierActivities";
import UseToggle from "../../../../../Hooks/UseToggle";
import AddCorierForm from "./AddCorierForm";
import Pagination from "../../../../Pagination";
import ManageCorierOrder from "./ManageCorierOrder";
import { usersOnboardingService } from "../../../../../APIServices/usersOnboarding";
import { FaEnvelope, FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import CorierDetail from "./CorierDetail";
import { eiwrsCorierManagementServices } from "../../../../../APIServices/EIWRS/ShipmentManagement/eiwrsCorierManagementServices";
import { FaGlobe } from "react-icons/fa6";

const CorierDataList = ({ onMouseDown, tableRef }) => {
  const [searchData, setSearchData] = useState("");
  const [rowId, setRowId] = useState("");
  const [rowData, setRowData] = useState("");
  const [historyLoader, setHistoryLoader] = useState(false);
  const [activityLoader, setActivityLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("properties");
  const [corierColumns, setCorierColumns] = useState([]);
  const [corierColumnsCount, setCorierColumnsCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [corierHistory, setCorierHistory] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [countryId, setCountryId] = useState("");
  const [stateId, setStateId] = useState("");
  const [corierRows, setCorierRows] = useState([]);
  const [corierRowsCount, setCorierRowsCount] = useState(0);
  const [corierDeletedRows, setCorierDeletedRows] = useState([]);
  const [corierDeletedRowsCount, setCorierDeletedRowsCount] = useState(0);
  const [corierActivity, setCorierActivity] = useState([]);
  const [corierActivityCount, setCorierActivityCount] = useState(0);
  const {
    toggle, setToggle,
    toggle1, setToggle1,
    toggle3, setToggle3,
    toggle4, setToggle4,
    toggle5, setToggle5,
    toggle6, setToggle6,
    toggle7, setToggle7,
  } = UseToggle();
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const [isFormOpen, setIsFormOpen] = useState(false);

  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getStudyCorierColumnData = async (e) => {
    setLoading(true);
    let data = await eiwrsCorierManagementServices.getStudyCorierColumnData(
      "active",
      studyId
    );
    setCorierColumns(data?.data || []);
    setCorierColumnsCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(corierRowsCount / itemsPerPage);

  const getStudyCorierRowData = async (e) => {
    setLoading(true);
    let data = await eiwrsCorierManagementServices.getStudyCorierRowData(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setCorierRows(data?.data || []);
    setCorierRowsCount(data?.count || 0);
    setRowData("");
    setRowId("");
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedStudyCorierRowData = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsCorierManagementServices.getStudyCorierRowData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setCorierDeletedRows(data?.data || []);
    setCorierDeletedRowsCount(data?.count || 0);
  };

  const getStudyCorierAutitTrials = async (e) => {
    setHistoryLoader(true);
    let data = await eiwrsCorierManagementServices.getStudyCorierAuditTrials(
      studyId,
      rowData?.corierId
    );
    setCorierHistory(data?.data || []);
    setHistoryLoader(false);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "corierData",
      studyId,
      rowData?.corierId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setCorierActivity(data?.data || []);
    setCorierActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const getCountries = async (e) => {
    let data = await usersOnboardingService.getCountries(e);
    setCountryList(data);
  };

  const getStates = async (e) => {
    let data = await usersOnboardingService.getStates(e);
    setStateList(data);
  };

  const getCities = async (e) => {
    let data = await usersOnboardingService.getCities(e);
    setCityList(data);
  };

  useEffect(() => {
    if (countryId) {
      getStates(countryId);
    }
  }, [countryId]);

  useEffect(() => {
    if (stateId) {
      getCities(stateId);
    }
  }, [stateId]);

  useEffect(() => {
    getStudyCorierColumnData();
    getCountries()
  }, []);

  useEffect(() => {
    getStudyCorierRowData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreStudyCorierRow = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} corier!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.type = type;
        let data = await eiwrsCorierManagementServices.softDeleteRestoreStudyCorierRow(userData);
        if (data?.statusCode === 200) {
          getStudyCorierRowData();
          getDeletedStudyCorierRowData();
          setRowId("");
          if (type === "restore") {
            getDeletedStudyCorierRowData(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  const getVisibleColumns = () => {
    return corierColumns?.filter(col => !tableColumns[col?.columnName]) || [];
  };

  const handleTabClick = (tab, row, fetchData = false) => {
    setRowData(row);
    setRowId(row?._id);
    setActiveTab(tab);
    if (tab === "updated History" && fetchData) {
      getStudyCorierAutitTrials();
    } else if (tab === "Corier Activities" && fetchData) {
      getStudyAuditTrials(1, 10);
    }
  };

  return (
    <>
      <div className="overflow-auto" style={{ height: "calc(100vh - 145px)" }}>
        <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
          <div className="hstack gap-1">
            <i
              title={isFormOpen ? "Close Form" : "Add New Corier"}
              onClick={() => {
                setIsFormOpen(!isFormOpen);
                setRowId("");
              }}
              className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"}`}
            />
            <div className="vr"></div>
            {corierRowsCount > 0 && (
              <div className="position-relative">
                <Form.Control
                  type="Search"
                  onChange={(e) => setSearchData(e.target.value)}
                  value={searchData}
                  placeholder="Search..."
                  style={{ width: 200, padding: "3px 10px" }}
                />
                <CiSearch
                  className="CP position-absolute bg-white"
                  title="Search"
                  style={{ width: 15, top: 4, right: 7 }}
                />
              </div>
            )}
          </div>
          <div className="hstack gap-2">
            {corierRowsCount > 0 && (
              <>
                <button
                  onClick={() => {
                    setToggle6();
                  }}
                  className="updateProfile"
                  style={{ fontSize: 12 }}
                >
                  Manage Order
                </button>
              </>
            )}
            {corierDeletedRowsCount > 0 && (
              <button
                onClick={() => {
                  setToggle1();
                  getDeletedStudyCorierRowData(pageNumberDeleted, itemsPerPageDeleted);
                }}
                className="updateProfile"
              >
                Deleted History
              </button>
            )}
          </div>
        </div>
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          style={{ height: "calc(100vh - 182px)" }}
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddCorierForm
              getStudyCorierRowData={getStudyCorierRowData}
              countryList={countryList}
              stateList={stateList}
              cityList={cityList}
              setCountryId={setCountryId}
              setStateId={setStateId}
            />
          )}
          {loading ? (
            <PageLoader />
          ) : corierRowsCount === 0 ? (
            <NoDataFoundTable MSG={"Corier Data not found!"} />
          ) : corierRows?.length === 0 ? (
            <NoDataFoundTable MSG={"Search Corier Data not found!"} />
          ) : (
            <>
              <div className="p-2">
                <Row className="g-3">
                  {corierRows?.map((row, index) => {
                    const visibleColumns = getVisibleColumns();
                    return (
                      <Col key={row._id} xs={12} md={6} xl={4}>
                        <Card className="app-card h-100 shadow-sm border-0">
                          <Card.Body>
                            <div className="align-items-start mb-3">
                              <div>
                                <div className="hstack justify-content-between">
                                  <h6 className="fw-bold mb-1">
                                    {row?.row?.CORIERNAME}
                                  </h6>
                                  <div className="hstack gap-2">
                                    <Badge
                                      bg="info-subtle"
                                      style={{padding: "1px 10px"}}
                                      className={`br3 text-info px-2 py-1 text-capitalize`}
                                      title="Service Type"
                                    >
                                      {row?.row?.SERVICETYPE}
                                    </Badge>
                                    <Badge
                                      bg="success-subtle"
                                      style={{padding: "1px 10px"}}
                                      className={`br3 text-success px-2 py-1 text-capitalize`}
                                    >
                                      Active
                                    </Badge>
                                  </div>
                                </div>
                                <div className="text-muted small">
                                  {row?.row?.CORIERID} ({row?.row?.COMPANYTYPE})
                                </div>
                                <div className="text-muted fw-bold small mt-2">
                                  Support Tracking: {row?.row?.SUPPORTTRACKING}
                                </div>
                              </div>

                            </div>
                            <div className="mb-2 mt-1">
                              {row?.row?.COMPANYWEBSITE && (
                                <div className="hstack gap-2 text-muted small mt-1">
                                  <FaGlobe size={12} />
                                  <span>{row?.row?.COMPANYWEBSITE}</span>
                                </div>
                              )}
                              {row?.row?.CONTACTEMAIL && (
                                <div className="hstack gap-2 text-muted small mt-1">
                                  <FaEnvelope size={12} />
                                  <span>{row?.row?.CONTACTEMAIL}</span>
                                </div>
                              )}
                              {row?.row?.CONTACTPHONE && (
                                <div className="hstack gap-2 text-muted small mt-1">
                                  <FaPhone size={12} />
                                  <span>{row?.row?.CONTACTPHONE}</span>{row?.row?.ALTERNATECONTACTPHONE && <span>, {row?.row?.ALTERNATECONTACTPHONE}</span>}
                                </div>
                              )}
                              {row?.row?.COUNTRY &&
                                <div className="hstack gap-2 text-muted small mt-1">
                                  <FaMapMarkerAlt size={12} />
                                  <span>{row?.row?.COUNTRY}{(row?.row?.STATE || row?.row?.CITY || row?.row?.ZIPCODE) && ","}</span>
                                  {row?.row?.STATE &&
                                    <span>{row?.row?.STATE}{(row?.row?.CITY || row?.row?.ZIPCODE) && ","}</span>
                                  }
                                  {row?.row?.CITY &&
                                    <span>{row?.row?.CITY}{row?.row?.ZIPCODE && ","}</span>
                                  }
                                  {row?.row?.ZIPCODE &&
                                    <span>{row?.row?.ZIPCODE}</span>
                                  }
                                </div>
                              }
                            </div>
                          </Card.Body>
                          <Card.Footer className="bg-white border-top">
                            <div className="hstack flex-wrap gap-1 justify-content-end">
                              <button
                                className="updateProfile"
                                style={{padding: "1px 10px"}}
                                onClick={() => {
                                  handleTabClick("properties", row);
                                  setToggle5();
                                }}
                              >
                                Properties
                              </button>
                              <button
                                className="updateProfile"
                                style={{padding: "1px 10px"}}
                                onClick={() => {
                                  handleTabClick(
                                    "updated History",
                                    row,
                                    true
                                  );
                                  setToggle4();
                                }}
                              >
                                History
                              </button>
                              <button
                                className="updateProfile"
                                style={{padding: "1px 10px"}}
                                onClick={() => {
                                  handleTabClick(
                                    "Corier Activities",
                                    row,
                                    true
                                  );
                                  setToggle3();
                                }}
                              >
                                Activities
                              </button>
                              <button
                                className="updateProfile"
                                style={{padding: "1px 10px"}}
                                onClick={() => {
                                  setRowData(row);
                                  setToggle7();
                                }}
                              >
                                View
                              </button>
                              <button
                                className="updateProfile"
                                style={{padding: "1px 10px"}}
                                onClick={() => {
                                  setRowData(row);
                                  setToggle();
                                }}
                              >
                                Edit
                              </button>
                              <button
                                className="removeProfile"
                                style={{padding: "1px 10px"}}
                                onClick={() =>
                                  softDeleteRestoreStudyCorierRow(
                                    row?._id,
                                    "delete"
                                  )
                                }
                              >
                                Delete
                              </button>
                            </div>
                          </Card.Footer>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </div>

              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={corierRowsCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
      </div>
      {/* Manage Corier Order Offcanvas */}
      <ManageCorierOrder
        Show={!toggle6}
        Hide={setToggle6}
        Title="Manage Corier Order"
        getStudyCorierRowData={getStudyCorierRowData}
      />

      {/* Edit Corier Modal */}
      <UpdateCorier
        Show={!toggle}
        Hide={setToggle}
        rowData={rowData}
        setRowId={setRowId}
        corierColumns={corierColumns}
        countryList={countryList}
        stateList={stateList}
        cityList={cityList}
        setCountryId={setCountryId}
        setStateId={setStateId}
        getStudyCorierRowData={getStudyCorierRowData}
        Title={"Update Corier"}
      />

      {/* View Corier Modal */}
      <CorierDetail
        Show={!toggle7}
        Hide={setToggle7}
        rowData={rowData}
        corierColumns={corierColumns}
        Title={`View ${rowData?.row?.CORIERNAME} Details`}
      />

      {/* Deleted Corier Modal */}
      <DeletedCorier
        Show={!toggle1}
        Hide={setToggle1}
        studyId={studyId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        corierDeletedRows={corierDeletedRows}
        getDeletedStudyCorierRowData={getDeletedStudyCorierRowData}
        corierDeletedRowsCount={corierDeletedRowsCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreStudyCorierRow={softDeleteRestoreStudyCorierRow}
        Title={"Deleted Corier History"}
      />

      {/* Corier Activities Offcanvas */}
      <Offcanvas
        show={!toggle3}
        onHide={setToggle3}
        placement="end"
        style={{ width: 900 }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Corier Activities - {rowData?.row?.CORIERNAME || rowData?.row?.CORIERID || ""}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <CorierActivities
            onMouseDown={onMouseDown}
            tableRef={tableRef}
            corierActivity={corierActivity}
            activityLoader={activityLoader}
            getStudyAuditTrials={getStudyAuditTrials}
            rowData={rowData}
            corierActivityCount={corierActivityCount}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {/* Updated History Offcanvas */}
      <Offcanvas
        show={!toggle4}
        onHide={setToggle4}
        placement="end"
        style={{ width: 900 }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Updated History - {rowData?.row?.CORIERNAME || rowData?.row?.CORIERID || ""}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <CorierUpdatedHistory
            onMouseDown={onMouseDown}
            tableRef={tableRef}
            getStudyCorierAutitTrials={getStudyCorierAutitTrials}
            corierHistory={corierHistory}
            rowData={rowData}
            historyLoader={historyLoader}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {/* Properties Offcanvas */}
      <Offcanvas
        show={!toggle5}
        onHide={setToggle5}
        placement="end"
        size="lg"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Properties - {rowData?.row?.CORIERNAME || rowData?.row?.CORIERID || ""}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <CorierProperties
            onMouseDown={onMouseDown}
            tableRef={tableRef}
            rowData={rowData}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default CorierDataList;